import { useQuery } from '@tanstack/react-query';
import getRequestApproval from 'Api/reschedule/getRequestApproval';
import getRequestApprovalRequest from './model/request/getRequestApprovalRequest';
import getRequestApprovalResponse from './model/response/getRequestApprovalResponse';

const useGetRequestApproval = (queryParams) => {
  return useQuery({
    queryKey: ['request-approval', queryParams],
    queryFn: async () => {
      const queries = getRequestApprovalRequest(queryParams);

      const response = await getRequestApproval(queries);

      const result = getRequestApprovalResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetRequestApproval;
